<template>
  <ui-modal
    :show="showNotic"
    type="tag"
    :title="title"
    iconType="notice"
    @close="closeModal()"
  >
    <div class="inner-content">
      <div class="scroll-box" v-html="$lg(config, 'registration_notic', '')"></div>
    </div>
    <div class="agree-box">
      <div class="bg"></div>
      <button class="btn" :disabled="count > 0" @click="handleAgree">
        <ui-frame-bg colorType="yellow">
          <template v-if="!loading">
            <div v-if="count > 0" class="label-box">
              <span class="label-shadow">{{ agree_before }}{{ count }}{{ agree_after }}</span>
              <span class="label-text">{{ agree_before }}{{ count }}{{ agree_after }}</span>
            </div>
            <div v-else class="label-box">
              <span class="label-shadow">我已阅读，并同意</span>
              <span class="label-text">我已阅读，并同意</span>
            </div>
          </template>
          <template v-else>
            <div class="label-box">
              <span class="label-shadow">...</span>
              <span class="label-text">...</span>
            </div>
          </template>
        </ui-frame-bg>
      </button>
    </div>
  </ui-modal>
</template>

<script>
import UiModal from "@/components/ui-modal.vue";
import { mapState } from "vuex";
import * as api from '@/service/index'
import UiFrameBg from '@/components/ui-frame-bg';

export default {
  components: { UiModal, UiFrameBg },
  inject: ['reqApplyInfo', 'json_config', 'promptMsg', 'handleStep', 'updateInfo'],
  props: {
    agree: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      showNotic: false,
      title: '报名须知',
      agree_before: '我已阅读，并同意（',
      count: 10,
      agree_after: 'S）',
      loading: false
    }
  },
  computed: {
    ...mapState(['token']),
    config() {
      return this.json_config()
    },
  },
  methods: {
    showModal() {
      this.showNotic = true;

      if(!this.agree) {
        this.timer && clearInterval(this.timer);
        this.count = 10;
        this.timer = setInterval(() => {
          this.count -= 1;
          if(this.count <= 0) {
            // 倒计时结束
            clearInterval(this.timer)
          }
        }, 1000)
      }else {
        this.count = 0;
      }
    },
    closeModal() {
      this.showNotic = false;

      this.timer && clearInterval(this.timer)
    },
    handleAgree() {
      // console.log(this.agree)
      if(!this.agree && this.token) {
        // API agree状态更新
        console.log('-- 已同意 API --')
        this.loading = true;
        // 报名入口关闭后这里的新用户还能报名
        api.agreeNotic(this.token).then(r => {
          // console.log(r)
          if(r.status == 200 && r.data.success) {
            // API 重新更新状态
            // this.reqApplyInfo();
            // 同意后直接跳第二页
            this.handleStep(2);
            // 更新同意状态
            this.updateInfo('agree', 1)
          }

          this.loading = false;
          this.closeModal();
        })
        this.closeModal();
      }else {
        this.closeModal();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.inner-content {
  flex: 1;
  width: 988px;
  margin: 30px 0 0 64px;
  overflow-x: hidden;
  overflow-y: scroll;

  .scroll-box {
    width: 96%;
    white-space: pre-line;
    font-size: 20px;
    font-weight: 500;
    color: #666;
    padding-bottom: 60px;
    ::v-deep p {
      margin-top: 0;
      margin-bottom: 15px;
      display: flex;
      img {
        width: 21px;
        height: 21px;
        padding-top: 3px;
        margin-right: 4.5px;
      }
    }
    ::v-deep h3 {
      font-weight: normal;
      margin: 30px 0 15px;
    }
  }
}
.agree-box {
  position: relative;
  width: 100%;
  height: 80px;
  text-align: center;
  .bg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 132px;
    background-image: $bg_decorate;
    background-size: 103%;
    background-position: 0% 97%;
  }
  .btn {
    position: relative;
    height: 70px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
    font-size: 27px;
    font-weight: bold;
    margin: 0 auto;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    &:active {
      opacity: 0.8;
    }

    ::v-deep .ui-frame-bg .inner-box {
      padding: 0 28px;
    }
  }
}
</style>